import PausedGoalChip from './PausedGoalChip';

export default PausedGoalChip;
